import { render, staticRenderFns } from "./ReportsPagePreview.vue?vue&type=template&id=2127c8f1&scoped=true&"
import script from "./ReportsPagePreview.vue?vue&type=script&lang=js&"
export * from "./ReportsPagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127c8f1",
  null
  
)

export default component.exports